module.exports = " <div class=alert v-show=msg transition=expand>{{msg}}</div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
 ** module id = 41
 ** module chunks = 1
 **/